import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Carrieres from './pages/Carrieres';
import Projets from './pages/Projets';
import ForprodeDetail from './pages/ForprodeDetail';
import BilanCohorte1 from './pages/BilanCohorte1';
import Bailleurs from './pages/Bailleurs';
import Contact from './pages/Contact';
import Candidater from './pages/Candidater';
import APropos from './pages/APropos';
import Actualites from './pages/Actualites';
import ArticleDetail from './pages/ArticleDetail';
import AtosDaDetail from './pages/AtosDaDetail';
import Admin from './pages/Admin';
import Banner from './components/Banner';
import MentionsLegales from './pages/MentionsLegales';
import Confidentialite from './pages/Confidentialite';
import NotFound from './pages/NotFound';
import './index.css';
import './pages/Home.css';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // Ne pas scroller en haut si la navigation cible un ancre (#section)
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function ScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1); // retire le "#"
    // Retry jusqu'à ce que l'élément soit dans le DOM (page asynchrone)
    let attempts = 0;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        // Délai court pour laisser le layout se stabiliser après le rendu
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
      } else if (attempts < 15) {
        attempts++;
        setTimeout(tryScroll, 100);
      }
    };
    tryScroll();
  }, [pathname, hash]);
  return null;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return isAdmin ? children : (
    <>
      <Navbar />
      <Banner />
      {children}
      <Footer />
    </>
  );
}

function ParallaxEffect() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const elements = document.querySelectorAll('[data-parallax]');
          elements.forEach(el => {
            const factor = parseFloat(el.dataset.parallax) || 0.15;
            el.style.transform = `translateY(${window.scrollY * factor}px)`;
          });
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ScrollToHash />
      <ParallaxEffect />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projets" element={<Projets />} />
          <Route path="/projets/forprode-40-ia" element={<ForprodeDetail />} />
          <Route path="/projets/forprode-40-ia/bilan" element={<BilanCohorte1 />} />
          <Route path="/projets/atos-digital-academy" element={<AtosDaDetail />} />
          <Route path="/projets/:slug" element={<Projets />} />
          <Route path="/carrieres" element={<Carrieres />} />
          <Route path="/bailleurs" element={<Bailleurs />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/candidater" element={<Candidater />} />
          <Route path="/actualites" element={<Actualites />} />
          <Route path="/actualites/:slug" element={<ArticleDetail />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/*" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
